export default "__VITE_ASSET__BTqnv4Dx__"